import { LKDate } from 'loankeeper-common/helpers/Date'

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_manual_reserve',
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnDefs: [
    { headerName: 'ResDate', field: 'ResDate' },
    { headerName: 'ManResRate', field: 'ManResRate' },
    { headerName: 'EndDate', field: 'EndDate' },
  ],

  columnConfigs: {
    ResDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    EndDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },
  },
  getContextMenuItems: () => [],
}

export default config
